import { Modal } from '@material-ui/core';
import { DataGrid, GridToolbar, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from '@material-ui/data-grid';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { configs, downloadDoc, downloadImage, formatCurrency } from '../../../assets/Config';
import '../../../assets/styles/RM.css'
import { downloadCompanyDataDoc } from '../../../services/apis/companyManagement/CMApi';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import { useCMContext } from '../../../services/contexts/companyManagement/CMContext';
import DeleteModalPage from '../../includes/DeleteModalPage';
import CompanyHighlightMgmt from '../miscellaneous/StatusManagement/CompanyHighlightMgmt';
import { CompanyFileList } from '../companyManagement/CompanyFilesPage';

const corporateActionFileType = { key: "corporate_action", fields: [], accept: ["application/pdf"], sequence: false }

export default function ListCorpActionPage() {

    const { companyList, setCompanyList, getAllCompaniesList, downloadFile, setEditCompany, setEditCompanyData, editCompanyData, getCompanyDataById, setShowDeletedCompanies, showDeletedCompanies, addCompanyStock, getCompanyStock, getAllCorporateActionList, corporateAction } = useCMContext()
    const { setShowDelete, setShowSuccess, allowedFunc, setHighlightManagement } = useLogin()

    const history = useHistory()
    const [deleteId, setDeleteId] = useState({})

    const [companyData, setCompanyData] = useState("")
    const [filesAction, setFilesAction] = useState(null)

    const closeFilesModal = () => {
        setFilesAction(null)
        getAllCorporateActionList()
    }

    const columns = [{ field: "id", headerName: "ID", minWidth: 100, flex: 0.5, hide: true, filterable: false },
    { field: "company_name", headerName: "Company Name", minWidth: 300, flex: 0.5, cellClassName: "break-text" },
    { field: "action_type", headerName: "Action Type", minWidth: 100, flex: 0.5, cellClassName: "break-text" },
    { field: "record_date", headerName: "Record Date/Start Date", minWidth: 100, flex: 0.5, cellClassName: "break-text" },
    { field: "from_date", headerName: "End Date", minWidth: 100, flex: 0.5, cellClassName: "break-text" },
    { field: "data", headerName: "Data", minWidth: 100, flex: 0.5, cellClassName: "break-text" },
    { field: "remark", headerName: "Remark", minWidth: 100, flex: 0.5, cellClassName: "break-text" },
    { field: "financial_year", headerName: "Financial Year", minWidth: 100, flex: 0.5, cellClassName: "break-text" },
    {
        field: "is_processed", headerName: "Processed", minWidth: 100, flex: 0.5, cellClassName: "break-text",
        renderCell: (params) => {
            return <span>{params.row.is_processed ? "Yes" : "No"}</span>
        }
    },
    { field: "processed_at", headerName: "Processed At", minWidth: 150, flex: 0.5, cellClassName: "break-text" },
    {
        field: "is_reversed", headerName: "Reversed", minWidth: 100, flex: 0.5, cellClassName: "break-text",
        renderCell: (params) => {
            return <span>{params.row.is_reversed ? "Yes" : "No"}</span>
        }
    },
    { field: "reversed_at", headerName: "Reversed At", minWidth: 150, flex: 0.5, cellClassName: "break-text" },
    { field: "timestamp", headerName: "Timestamp", minWidth: 100, flex: 0.5, cellClassName: "break-text" },
    {
        field: "files", headerName: "Documents", minWidth: 120, flex: 0.3, cellClassName: "break-text", filterable: false,
        valueGetter: (params) => Array.isArray(params.row.files) ? params.row.files.map((file) => file.file_original_name).join(", ") : "",
        renderCell: (params) => {
            if (!params.row.file_group_id || params.row.file_group_id === "-") {
                return "-"
            }
            const count = Array.isArray(params.row.files) ? params.row.files.length : 0
            return <a href="#" className="custom-link" onClick={(e) => {
                e.preventDefault()
                setFilesAction(params.row)
            }}>{count ? `Documents (${count})` : "Upload"}</a>
        }
    },
    {
        field: "reverse", headerName: " ", minWidth: 90, flex: 0.1, cellClassName: "break-text",  renderCell: (params) => {
            if (params.row.is_reversed) {
                return null
            }
            return <a href="#" className="custom-link text-warning" onClick={(e) => {
                e.preventDefault()
                setDeleteId({
                    "category": configs.modules.cam,
                    "type": "Corporate Action",
                    "data": params.row,
                    "id": params.row.id,
                    "action": "reverse"
                })
                setShowDelete(true)
            }}>Reverse</a>
        }
    },
    {
        field: "delete", headerName: " ", minWidth: 65, flex: 0.1, cellClassName: "break-text text-danger",  renderCell: (params) => {
            return <a href="#" className="custom-link text-danger" onClick={(e) => {
                e.preventDefault()
                setDeleteId({
                    "category": configs.modules.cam,
                    "type": "Corporate Action",
                    "data": params.row,
                    "id":params.row.id
                })
                setShowDelete(true)
            }}>Delete</a>
        }
    },
    ]

    useEffect(() => {
        (async () => {
            try {
                await getAllCorporateActionList()
            } catch (error) {

            }
        })()
    }, [])

    function CustomToolbar() {
        try {

            return <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport csvOptions={{ allColumns: true }} />
            </GridToolbarContainer>

        } catch (error) {
            console.error(error);
        }
    }


    // role list page ui code
    return (
        <div id="companyListPage" className='d-md-block' style={{ width: "100%" }}>
            <div className="row d-flex align-items-center mt-2 ml-3 mb-1 mr-2">
                <div className="col-lg-6 col-8 m-0 p-0">
                    <p className="h4 text-custom-grey">Corporate Action Management</p>
                </div>
                {/* <div className="col-lg-6 col-4 text-right m-0 p-0">
                    {allowedFunc.includes(configs.functionList["company_management:delete_or_restore_company"]) ?
                        <a href="#" className="custom-link" onClick={(e) => {
                            e.preventDefault()
                            setCompanyList("")
                            setShowDeletedCompanies(!showDeletedCompanies)
                        }}><i className={showDeletedCompanies ? "fas fa-user mr-2" : "fas fa-user-slash mr-2"}></i>{showDeletedCompanies ? "Active Companies" : "Deleted Companies"}</a>
                        : null}
                </div> */}
            </div>
            <div className='row m-0 mx-3 p-0 d-md-none d-block'>
                <a href='#' className='custom-link' onClick={(e) => {
                    e.preventDefault()
                    document.getElementById("rmCreateCompany").classList.toggle('d-none')
                    document.getElementById("companyListPage").classList.toggle('d-none')
                }}><p className='m-0 p-0'>Add New Action</p></a>
            </div>
            {corporateAction ?
                <div className="nm-role-table m-2">
                    <DataGrid
                        rows={corporateAction}
                        headerHeight={30}
                        rowHeight={40}
                        columns={columns}
                        resizable={true}
                        autoPageSize
                        pagination
                        components={{
                            Toolbar: CustomToolbar,
                        }}

                    // onSelectionModelChange={onRowSelected}
                    />
                </div>
                : <div className="loader"></div>}
            {/* --------------------------------Corporate Action Documents Modal--------------------------------- */}
            <Modal open={!!filesAction} onClose={closeFilesModal}>
                <div className="modal-fade" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header border-0">
                                <h5>Documents{filesAction ? ` - ${filesAction.company_name} (${filesAction.action_type})` : ""}</h5>
                                <button type="button" className="close" aria-label="Close" onClick={closeFilesModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body py-3" style={{ maxHeight: "500px", overflowY: "auto" }}>
                                {filesAction ?
                                    <CompanyFileList companyId={filesAction.company_id} fileType={corporateActionFileType} groupId={filesAction.file_group_id} />
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <DeleteModalPage {...deleteId} />
            <CompanyHighlightMgmt />
        </div>
    )
}